import { FiltersController, IPredicate, Input, useDebounce } from '@centra/centra-ui'
import React, { ChangeEvent, FC, useEffect, useState } from 'react'
import { updateInputValue } from '../../AllFiltersModal/SingleModalFilter/utils'
import { getQueryObjFromPredicates, updatePredicateInput } from '../../FilterComponent/utils'
import { INPUT_DEBOUNCE_TIME } from '../../FilterComponent/consts'

interface IFilterComponentInputInputProps {
  predicate: IPredicate[]
  controller: FiltersController
  filterName: string
  notInModal?: boolean
  label?: string
}

export const FilterComponentInput: FC<IFilterComponentInputInputProps> = ({
  predicate,
  controller,
  filterName,
  notInModal,
  label,
}) => {
  const [inputValue, setInputValue] = useState('')

  useEffect(() => {
    if (!predicate.length) {
      setInputValue('')
    }

    if (notInModal) {
      const queryObj = getQueryObjFromPredicates(predicate)
      setInputValue(queryObj.taskId ? (queryObj.taskId[0] as string) : '')
    }

    updateInputValue({ predicate, setInputValue })
  }, [predicate])

  const debouncedInputPredicatesChange = useDebounce(() => {
    updatePredicateInput({ predicate, v: inputValue, filterName, controller })
  }, INPUT_DEBOUNCE_TIME)

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const trimmedValue = e.target.value.trim()
    if (Number(trimmedValue) || Number(trimmedValue) === 0) {
      setInputValue(trimmedValue)
      notInModal ? debouncedInputPredicatesChange() : controller.onChange(filterName, trimmedValue)
    }
  }
  return (
    <Input
      id="modalFilterSingleInput"
      showNotification={!!notInModal}
      size={notInModal ? 'sm' : 'md'}
      placeholder={label ? label : undefined}
      onChange={handleInputChange}
      value={inputValue}
    />
  )
}
